import { Menu } from 'antd';
import styled from 'styled-components';

export const MenuStyled = styled(Menu)`
	margin: 10px 0;
	transition: all 0.5s ease !important;
`;
